<!--
 * @LastEditTime: 2020-03-02 16:44:45
 * @Description: 统计指标
 * @Date: 2020-02-27 20:43:02
 * @Author: @虾哔哔
 -->
<template>
  <div class="statistical">
    <ul>
      <li
        v-for="(item, index) in overviewFormatting"
        :key="index"
        style="background-color:white"
      >
        <p :style="`background-color:${item.color};box-shadow:${item.boxShadow}`"><i :class="item.icon" class="iconfont" :style="`font-size:${item.size};padding:${item.padding}`" ></i></p>
        <div  class="text-wrap">
          <div class="number">
            <b>{{ item.data }}</b>
          </div>
          <el-tooltip :content="item.tips" placement="top">
            <span class="tool-fontsize14 text">{{ item.text }}</span>
          </el-tooltip>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          user_count: 0, //服务人数
          session_count: 0, // 已完成会话数
          manual_count: 0, // 服务转人工
          chat_count: 0, // 总咨询量
          known_chat_count: 0, // 知识命中数
          unknown_chat_count: 0 // 未知回答数
        };
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    overviewFormatting() {
      return [
        {
          icon: "iconfuwu",
          text: "服务人数",
          tips: "访问机器人的独立用户数，每日去重",
          color: "#4162FB",
          data: this.data.user_count,
          size:'30px',
          padding:'8px 0 0 16px',
          boxShadow:'0px 5px 20px 0px rgba(0,99,255,0.3)'

        },
        {
          icon: "iconhuihuaxuanzhong",
          text: "已完成会话",
          tips: "机器人与用户已经完成的会话数量",
          color: "#FE974A",
          data: this.data.session_count,
          size:'26px',
          padding:' 5px 0 0 6px',
          boxShadow:'0px 5px 20px 0px rgba(254,151,74,0.3)'

        },
        {
          icon: "iconfuwu1",
          text: "服务转人工",
          tips: "机器人服务过程中，用户选择转人工的会话数量",
          color: "#FFC442",
          data: this.data.manual_count,
          size:'30px',
          padding:' 5px 0 0 16px',
          boxShadow:'0px 5px 20px 0px rgba(255,196,66,0.3)'

        },
        {
          icon: "iconjiqiren",
          text: "总咨询量",
          tips: "用户咨询机器人的问题总数，与机器人的回答数相等",
          color: "#3DD598",
          data: this.data.chat_count,
          size:'46px',
          padding:'0 0 0 1px',
          boxShadow:'0px 5px 20px 0px rgba(61,213,152,0.3)'
        },
        {
          icon: "iconshu11",
          text: "知识命中数",
          tips: "机器人命中业务知识和闲聊知识的数量",
          color: "#8F57F5",
          data: this.data.known_chat_count,
          size:'20px',
          padding:'0 0 0 1px',
          boxShadow:'0px 5px 20px 0px rgba(143,87,245,0.3)'
          
        },
        {
          icon: "iconweizhihuida",
          text: "未知回答数",
          tips: "机器人无法识别进行未知回复的数量",
          color: "#43AEF9",
          data: this.data.unknown_chat_count,
          size:'24px',
          padding:'0 0 0 1px',
          boxShadow:'0px 5px 20px 0px rgba(87,180,245,0.3)'

        }
      ];
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.statistical {
  margin-top: 20px;
  ul {
    display: grid;
    grid-template-columns: repeat(6,1fr);
    grid-template-rows:120px;
    grid-column-gap: 30px;
    li {
      display: flex;
      align-items: center;
      color: #fff;
      border-radius: 10px;
      padding: 0 0 0 20px;
      p{
        height: 50px;
        width: 50px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .text-wrap{
        color: #000;
        margin-left: 20px;
        .number{
          font-size: 30px;
        }
        .text{
          color:rgba(143,142,158,1);
          font-size: 14px;
        }
      }
      
    }
  }
}
</style>
